import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import man1 from '../assets/images/man1.jpg';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/AboutAiota.css'; // Import the CSS file
import { useNavigate } from 'react-router-dom';

const AboutAiota = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [hasError, setHasError] = useState(false); // ✅ Added error state

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  useEffect(() => {
    // ✅ Check for missing or broken content
    try {
      if (!heroBg || !man1) {
        throw new Error("Missing content");
      }
    } catch (err) {
      setHasError(true);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // ✅ Display fallback message if error occurs
  if (hasError) {
    return (
      <div style={{
        textAlign: "center",
        padding: "100px 20px",
        fontSize: "1.5rem",
        color: "#555"
      }}>
        This page is currently unavailable
      </div>
    );
  }

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="about-section">
            <Container>
              <h2>ALL INDIA OCCUPATIONAL THERAPISTS' ASSOCIATION HISTORICAL PERSPECTIVE</h2>
              <Row>
                <Col lg={7} className="mb-4">
                  <p>
                    The All India Occupational Therapists' Association (AIOTA) was founded in 1952 by Mrs. Kamala V. Nimbakar (née Elizabeth Lundy), an American, who served as its first President.
                  </p>
                  <p>
                    AIOTA is a member of the World Federation of Occupational Therapists (WFOT) and plays a key role in setting professional and educational standards for Occupational Therapy in India. Under her guidance on November 14th 1950 the Occupational Therapy Center with First OT School in India and Asia imparting Diploma Program was inaugurated by Union Health Minister Rajkumari Amrit Kaur, at K.E.M. hospital, Mumbai with Mrs. Nimbkar as its Hon. Director. This program was accredited by AIOTA in 1952 and was approved by WFOT in the year 1954. Many students from Sri Lanka, Malaya, Indonesia and other south east countries were trained at this center under her guidance and spread the word of Occupational Therapy in Asian region. Mrs. Nimbkar also attended First WFOT Council Meeting at Edinburgh as WFOT Delegate.
                  </p>
                </Col>
                <Col lg={5} className="mb-4 text-end">
                  <img
                    src={man1}
                    alt="About AIOTA"
                    className="about-img"
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <p>
                    The association has been instrumental in shaping the direction of Occupational Therapy education and practice in India, promoting professional development, advocacy, and creating awareness about the significance of the profession across the country. Through conferences, academic programs, and collaborative efforts, AIOTA ensures the continued advancement and recognition of Occupational Therapy.
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default AboutAiota;
